const uint8ArrayToHexStr = (uint8) => {
  if (uint8.byteLength === 0) {
    return "0x00";
  }
  return `0x${Array.from(uint8).map((i) => i.toString(16).padStart(2, "0")).join("")}`;
};
export {
  uint8ArrayToHexStr
};
//# sourceMappingURL=uint8ArrayToHexStr.js.map